<style lang="scss">

</style>
<!--eslint-disable-->
<template>
  <section class="text-center" v-if="loaded">
    <h3>{{title}}</h3>
    <h4 v-if="subtitle" class="font-weight-bolder my-2">{{subtitle}}</h4>

    <p v-if="note">{{note}}</p>

    <!-- Optional Text Field -->
    <div v-if="showTextField" class="my-3">
      <b-form-group :label="textFieldLabel" label-align="left">
        <b-form-input v-model="inputValue" placeholder="Enter reason here..." />
      </b-form-group>
    </div>

    <section class="d-inline-flex full-width mt-2">
      <div class="ui-spacer"></div>
      <b-button class="mr-2" @click="$emit('close', true)">Cancel</b-button>
      <b-button :variant="okVariant" @click="emitOk">Ok</b-button>
    </section>
  </section>
</template>
<!--eslint-enable-->

<script>
  export default {
    components: {},
    props: {
      title: {
        required: true,
        type: String,
      },
      // eslint-disable-next-line vue/require-default-prop
      subtitle: {
        required: false,
        type: String,
      },
      // eslint-disable-next-line vue/require-default-prop
      note: {
        required: false,
        type: String,
      },
      okVariant: {
        required: false,
        type: String,
        default: 'danger',
      },
      showTextField: {
        type: Boolean,
        default: false,
      },
      textFieldLabel: {
        type: String,
        default: 'Reason',
      },
    },
    data() {
      return {
        loaded: false, // used to change color variant as bootstrap does not update after mount
        inputValue: '', // Holds the user input
      };
    },
    mounted() {
      setTimeout(() => {
        this.loaded = true;
      });
    },
    methods: {
      emitOk() {
        // Emit the input value along with the Ok event
        this.$emit('ok', this.inputValue);
      },
    },
  };
</script>
